import { createFileRoute, Outlet } from '@tanstack/react-router';

import { GradientCenterLayout } from '@/shared/components/layouts';

export const Route = createFileRoute('/auth/_authLayout')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <GradientCenterLayout>
      <Outlet />
    </GradientCenterLayout>
  );
}
